export default __webpack_public_path__ + "static/media/login-video.c268b816.mp4";